import React, { useEffect as uEffect, useState as uState } from 'react'

import Navbar from '../../Components/Navbar/navbar'
import Footer from '../../Components/Footer/footer'

import ProductDesc from '../../Components/Cards/productDesc'

export default function productDetails() {


  const [prod, setProd] = uState([])

  const loadData = async () => {
    let response = await fetch('http://localhost:8000/cart/showCart', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    response = await response.json()
    setProd(response[0])
  }
  uEffect(() => {
    loadData()
  }, [])

  return (
    <>
      <Navbar/>
      {
        prod !== []
          ?
          prod.filter((item) => item.productTitle === localStorage.getItem('prod_title'))
            .map((data,index) => {
              return (
                <div key={index} className='row mb-3' id='seeMore'>
                  <ProductDesc medProduct={data} />
                </div>)
            }) : ''

      }

<Footer/>

    </>
  )
}